import HttpClient from './http.api';

export class SearchApiService {

	static searchData(data) {
		return HttpClient.get({ url: '/api/v1/web/search/?search=' + data });
	}
}
